import React from 'react';

import { Radio } from '@material-ui/core';

const CustomRadio = (props) => (
  <Radio {...props} color='primary' inputProps={{ role: 'radio' }} />
);

export default CustomRadio;
